import { UMark } from "./UMark";
import { site } from "@/site.config";

// Labeled upload placeholder. Set images[slotId].src in site.config.js to publish a photo.
// fit: "cover" (default) fills the frame; "contain" shows the whole graphic on `bg`.
// eager: load immediately with high priority (use for the hero image / LCP).
export const PhotoSlot = ({ slotId, aspect = "aspect-[4/5]", className = "", eager = false }) => {
  const slot = site.images[slotId] || {};
  const testId = `photo-slot-${slotId.toLowerCase().replace(/_/g, "-")}`;
  return (
    <div
      data-testid={testId}
      data-slot={slotId}
      className={`group relative overflow-hidden rounded-2xl border border-white/10 bg-navy ${aspect} ${className}`}
    >
      {slot.src ? (
        <img
          src={slot.src}
          alt={slot.alt || "Emmanuel Quezada, Founder and CEO of u-topia."}
          loading={eager ? "eager" : "lazy"}
          fetchPriority={eager ? "high" : undefined}
          decoding="async"
          className={`h-full w-full ${slot.fit === "contain" ? "object-contain" : "object-cover"}`}
          style={slot.bg ? { backgroundColor: slot.bg } : undefined}
        />
      ) : (
        <div className="flex h-full w-full flex-col items-center justify-center gap-3 p-6 text-center">
          <UMark size={44} on="navy" />
          <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-orange">
            Photo slot · {slotId}
          </p>
          <p className="text-sm text-white/60">{slot.caption}</p>
          {slot.note && <p className="text-xs text-white/35">{slot.note}</p>}
        </div>
      )}
    </div>
  );
};
